/** Português. See `en.ts` for what each key is and what it has to fit.
 *
 * The rail glyphs stay on the Latin WMO symbols; the pressure centers take
 * the Portuguese chart convention, A / B (anticiclone / baixa). */

import type { MessageKey } from "./en";

export const pt: Record<MessageKey, string> = {
  metaDescription:
    "Mapas meteorológicos ao vivo e gratuitos no navegador: previsões GFS, ECMWF e AIFS, animações de radar e satélite, trajetórias de tufões, radar 3D e diagramas skew-T.",
  pageTitleLive: "Mapa de previsão: {variable} · {model} {hours}H",
  pageTitleLiveObservation: "Mapa de observação: {variable} · {model} · últimas {hours} h",
  mapAria: "Mapa global de previsão de temperatura e precipitação",
  modelSwitchAria: "Conjunto de dados",
  variableSwitchAria: "Variável meteorológica",
  varTemp: "2M",
  varPrecip: "TAXA",
  varWind: "10M",
  varSolar: "FLUXO",
  varRadar: "CREF",
  varOrog: "OROG",
  varInfrared: "IV 10,4",
  varShortwave: "IV 3,9",
  varDustRgb: "RGB",
  varDustCf: "DEBRA",
  varZhouye: "ZHOUYE",
  varTrueColor: "COR",
  varGust: "RAJADA",
  varCloud: "TOTAL",
  varCape: "SOLO",
  varPwat: "COLUNA",
  varPtype: "TIPO",
  varCin: "INIB",
  varHpbl: "ALTURA",
  varVis: "VISIB",
  varDewPoint: "2M",
  varFeelsLike: "2M",
  varOmega: "VERT",
  varThetaE: "EQUIV",
  varCat: "EDR",
  varInflow: "FLUXO",
  varFront: "FRENTE",
  varHotspot: "FOCOS",
  varFfwi: "TEMPO FOGO",
  varFwalert: "ALERTA",
  varSst: "PELE",
  varIce: "COBERT.",
  varWave: "ALTURA",
  varAod: "TOTAL",
  varPm: "2.5",
  varDustsfc: "SOLO",
  varTsoil: "CAMADA 1",
  varSoilw: "CAMADA 1",
  varHumidity: "REL",
  varVapourFlux: "FLUXO",
  varPressure: "NÍV MAR",
  varHeight: "ALTURA",
  varPressureField: "CAMPO",
  varUnknownLayer: "CAMADA",

  glyphTmp2m: "T",
  glyphPrate: "R",
  glyphWind10m: "W",
  glyphDswrf: "S",
  glyphCref: "Z",
  glyphIr104: "I",
  glyphIr039: "C",
  glyphDustrgb: "P",
  glyphDustcf: "C",
  glyphZhouye: "Z",
  glyphTruecolor: "C",
  glyphGust: "G",
  glyphTcdc: "N",
  glyphCape: "C",
  glyphVis: "V",
  glyphPwat: "P",
  glyphCin: "I",
  glyphHpbl: "B",
  glyphPtype: "Y",
  glyphDpt2m: "D",
  glyphAptmp2m: "A",
  glyphVvel: "ω",
  glyphThetae: "θ",
  glyphCat: "ε",
  glyphInflow: "H",
  glyphFront: "F",
  glyphHotspot: "F",
  glyphFfwi: "T",
  glyphFwalert: "A",
  glyphTmpsfc: "S",
  glyphIce: "I",
  glyphWave: "H",
  glyphAod: "τ",
  glyphPm: "µ",
  glyphDustsfc: "P",
  glyphTsoil: "E",
  glyphSoilw: "M",
  glyphPressure: "P",
  glyphRh: "U",
  glyphQflux: "F",
  tipTemp: "Temperatura",
  tipHumidity: "Humidade relativa",
  tipWind: "Vento",
  tipPressure: "Pressão e altura geopotencial",
  tipVapourFlux: "Fluxo de vapor de água",
  tipCloud: "Nebulosidade",
  tipOmega: "Velocidade vertical",
  tipThetaE: "Temperatura potencial equivalente",
  tipCat: "Turbulência de ar claro",
  tipIce: "Gelo marinho",
  tipWave: "Ondas",
  tipAod: "Espessura óptica de aerossóis",
  tipPm: "Material particulado",
  tipTsoil: "Temperatura do solo",
  tipSoilw: "Humidade do solo",
  tipSatellite: "Imagem de satélite",
  levelSwitchAria: "Nível",
  levelCaption: "Nível",
  linesCaption: "Isolinhas",
  accumCaption: "Acumulado",
  accumRateGloss: "intensidade",
  accumTotalGloss: "acumulado {window}",
  modelHeading: "Conjuntos de dados",
  linesRemoveTitle: "Prima novamente para remover as isolinhas",
  fieldSectionAria: "Campo",
  overlaySectionAria: "Sobreposições",
  markSectionAria: "Marcas",
  tipMore: "Todas as camadas desta rodada",
  varMore: "Camadas",
  glyphMore: "+",
  fieldSheetAria: "Camadas",
  fieldSheetHeading: "Camadas",
  fieldGroupTemperature: "Temperatura",
  fieldGroupMoisture: "Umidade",
  fieldGroupSoil: "Solo",
  fieldGroupWind: "Vento",
  fieldGroupDynamics: "Dinâmica",
  fieldGroupRadiation: "Radiação e visibilidade",
  fieldGroupAerosol: "Aerossóis e qualidade do ar",
  fieldGroupOcean: "Oceano",
  fieldGroupHydrology: "Rios e cheias",
  fieldGroupSatellite: "Satélite",
  fieldGroupOther: "Outras",
  fieldGroupImagery: "Imagens diárias: NASA GIBS",
  gibsTrueColor: "REAL",
  gibsFalseColor: "FOGO",
  gibsTipTrue: "Cor real",
  gibsTipFire: "Falsa cor de fogo: queimadas em vermelho escuro",
  varParticles: "FLUXO",
  glyphParticles: "≈",
  varVolume: "NUVEM 3D",
  glyphVolume: "Q",
  levelAlone: "Só linhas",
  levelAloneTitle: "Só as linhas: o campo sai; prima de novo para o recuperar",
  creditsTrigger: "Fontes",
  creditsHeading: "Dados e créditos",
  creditsGfs: "Dados de previsão: GFS 0.25° e sflux",
  creditsHrrr: "Dados de previsão: HRRR 3 km, EUA contíguos",
  creditsGefsAero: "Previsão de aerossóis: GEFS-Aerosols 0,25°, AOD e partículas à superfície",
  creditsCmaDust: "Previsão de poeira: CMA-CW v1.0/DUST (WMO SDS-WAS Asian Center) 0,15° sobre a Ásia, via WMO WIS2",
  creditsSilam: "Previsão da qualidade do ar: FMI SILAM v6.1 global 0,2°, CC BY 4.0",
  creditsCfs: "Previsão sazonal: CFSv2, 9 meses, de 6 em 6 horas",
  creditsEcmwf: "Contém dados ECMWF modificados, CC BY 4.0",
  creditsIfsHres: "Adaptado do IFS da ECMWF pela ECMWF, licenciado sob CC BY 4.0; via Open-Meteo; IFS HRES ~9 km, reamostrado para 0,1°",
  creditsMrms: "Observações de radar: MRMS, EUA contíguos",
  creditsNexrad: "Radar individual: refletividade e velocidade radial, EUA",
  creditsJma: "Precipitação por radar: nowcast JMA, Japão (reamostrado)",
  creditsHimawari: "Imagens de satélite: Himawari-9 AHI, JMA, via NOAA Open Data (reprojetado)",
  creditsGoes: "Imagens de satélite: GOES-19 Leste e GOES-18 Oeste ABI, NOAA NESDIS, via NOAA Open Data (reprojetado)",
  creditsMeteosat: "Imagens de satélite: contém dados Meteosat da EUMETSAT modificados {year}; Meteosat-12 FCI, ciclo horário, CC-BY-4.0 (reprojetado)",
  creditsSounding: "Radiossondagens: TEMP GTS via WIS2, serviços meteorológicos nacionais",
  creditsAirport: "METAR e TAF de aeroportos: serviços meteorológicos via NOAA/NWS AWC",
  creditsFirms: "Incêndios ativos: LANCE FIRMS NRT, VIIRS 375 m e MODIS, NASA ESDIS",
  creditsGibs: "Imagens diárias: reflectância corrigida MODIS e VIIRS, NASA ESDIS",
  creditsRadar: "Mosaico de radar",
  creditsBasemap: "Mapa base: © colaboradores do OpenStreetMap",
  creditsTerrain: "Relevo do terreno: © Mapterhorn, fontes de dados de elevação",
  creditsPeaks: "Nomes e altitudes de picos: CC0",
  creditsCode: "Código-fonte: ringsaturn/xue",
  caseTag: "Caso",
  caseSummaryAria: "Resumo do caso",
  runCycle: "Ciclo do modelo",
  recordSpan: "Período do registro",
  latestObservation: "Última observação",
  latestNowcast: "Última previsão imediata",
  awaitingData: "A aguardar dados",
  validTimeLabel: "Hora de validade",
  observationTimeLabel: "Hora de observação",
  statsAria: "Estatísticas detalhadas",
  statsCloseAria: "Fechar estatísticas",
  bufferedFrames: "Em memória",
  downloadedBytes: "Transferido",
  formatLabel: "Formato",
  formatZarr: "Zarr",
  preloadProgressAria: "Progresso do pré-carregamento dos dados de previsão",
  statDataset: "Conjunto de dados",
  statGrid: "Grelha",
  statFrameCache: "Cache de fotogramas",
  statDecodeTime: "Tempo de descodif.",
  statDecodeRate: "Ritmo de descodif.",
  statViewport: "Amostragem",
  statConnection: "Ligação",
  awaitingManifest: "A aguardar o manifesto",
  legendPrateAria: "Escala de cores da intensidade de precipitação",
  timelineAria: "Controlos de tempo da previsão",
  playAnimation: "Reproduzir animação",
  pauseAnimation: "Pausar animação",
  playbackSpeed: "Velocidade de reprodução",
  exportOpenAria: "Exportar a animação",
  exportSheetAria: "Exportar a animação",
  exportHeading: "Exportar",
  exportFormat: "Formato",
  exportSize: "Tamanho",
  exportFps: "Quadros/s",
  exportRange: "Quadros",
  exportFrom: "De",
  exportTo: "Até",
  exportRun: "Exportar",
  exportCancel: "Cancelar",
  exportSummary: "{size}, {frames} quadros, {seconds} s, cerca de {bytes}",
  exportCapturing: "Capturando {done}/{total}",
  exportEncoding: "Codificando {percent}%",
  exportFailed: "Falha ao exportar",
  readingManifest: "A carregar o manifesto",
  forecastHourAria: "Hora de previsão",
  forecastDaysAria: "Segmentos diários da previsão",
  observationDaysAria: "Segmentos diários",
  mapMenuAria: "Opções do mapa",
  menuStats: "Estatísticas detalhadas",
  menuCopyDebug: "Copiar informação de depuração",
  errorTitle: "Dados indisponíveis",
  retry: "Tentar de novo",
  langPickerAria: "Idioma",
  langPickerHeading: "Idioma",
  themeToggleAria: "Alternar claro / escuro",
  viewGlobeAria: "Globo",
  viewTerrainAria: "Relevo 3D",
  viewContoursAria: "Curvas de nível",
  viewResetNorthAria: "Orientar para o norte",
  viewResetPitchAria: "Redefinir inclinação",
  viewBoxAria: "Close da tempestade: arraste uma caixa",
  viewSectionAria: "Corte vertical: arraste uma linha",
  viewDistanceAria: "Medir distância: clique nos pontos e de novo no último para terminar",
  viewAreaAria: "Medir área: clique nos vértices e de novo no primeiro ou no último para terminar",
  particlesToggle: "Partículas",
  particlesToggleAria: "Alternar a animação de partículas de vento",

  dataInterrupted: "Carregamento de dados interrompido",
  errorHint: "{message}. Confirme que executou make mvp e que a página é servida através de make serve.",
  loadFailed: "Falha ao carregar",
  webglLost: "WebGL indisponível: feche o navegador por completo e volte a abri-lo",
  saveData: "poupança",
  debugCopied: "Informação de depuração copiada",
  copyFailed: "Falha ao copiar",
  bundleResident: "Pacote totalmente em memória",
  viewportResident: "Vista atual totalmente carregada",
  streamingOnDemand: "Transmissão a pedido",
  receivingBundle: "A receber o pacote de previsão",
  receivingBundlePercent: "A receber o pacote {percent}%",
  readingIndex: "A ler o índice de dados",
  initializingDecoder: "A inicializar o descodificador",
  framesReady: "{count} fotogramas prontos",
  readingData: "A carregar dados",
  bundleLoadFailed: "Falha ao carregar o pacote de previsão",
  workerStartFailed: "O worker de descodificação não arrancou",
  decodeFailed: "Falha na descodificação",
  frameDecodeFailed: "Falha ao descodificar o fotograma: {message}",
  legendAria: "Escala de cores de {label}",
  legendInflow: "Fluxo quente e úmido",
  legendFront: "Zona frontal (gradiente θe)",
  legendHotspot: "Foco de calor (teste contextual a 3,9 µm)",
  legendFfwi: "Índice meteorológico de incêndio de Fosberg",
  legendFwalert: "Umidade relativa abaixo de 30 % com rajadas de 10 m/s ou mais",
  legendDustDust: "Poeira",
  legendDustThickHigh: "Nuvens altas espessas",
  legendDustThinHigh: "Nuvens altas finas",
  legendDustMid: "Nuvens médias",
  legendDustLow: "Nuvens baixas quentes",
  legendDustDesert: "Superfície desértica quente",
  legendDustSurface: "Mar e terra com vegetação",
  legendTruecolorCloud: "Nuvens e neve",
  legendTruecolorSea: "Mar",
  legendTruecolorLand: "Terra e vegetação",
  legendTruecolorNightCloud: "Nuvens à noite (infravermelho)",
  legendTruecolorNightGround: "Céu limpo à noite",
  legendPtypeRain: "Chuva",
  legendPtypeFreezingRain: "Chuva congelante",
  legendPtypeSnow: "Neve",
  legendPtypeIcePellets: "Grânulos de gelo",
  legendDisrpBelow: "Abaixo do nível de 1,5 anos",
  legendDisrp1p5: "≥ nível de 1,5 anos",
  legendDisrp2: "≥ nível de 2 anos",
  legendDisrp5: "≥ nível de 5 anos",
  legendDisrp20: "≥ nível de 20 anos",
  legendCatLight: "Leve",
  legendCatModerate: "Moderada",
  legendCatModerateSevere: "Moderada–severa",
  legendCatSevere: "Severa",
  varLabelTmp2m: "Temperatura a 2 m",
  varLabelPrate: "Intensidade de precipitação",
  varLabelDswrf: "Radiação solar",
  varLabelWind10m: "Vento a 10 m",
  varLabelWind80m: "Vento a 80 m",
  varLabelWind100m: "Vento a 100 m",
  varLabelCref: "Refletividade radar composta",
  varLabelRefl3d: "Refletividade radar 3D",
  varLabelCloud3d: "Água de nuvem 3D",
  varLabelOrog: "Orografia",
  varLabelIr104: "Imagem infravermelha (temperatura de brilho a 10,4 µm)",
  varLabelIr039: "Infravermelho de onda curta (temperatura de brilho a 3,9 µm)",
  varLabelDustrgb: "RGB de poeira (composição infravermelha)",
  varLabelDustcf: "Confiança de poeira DEBRA",
  varLabelZhouye: "Confiança de poeira ZHOUYE",
  varLabelTruecolor: "Cor real de dia, nuvens no infravermelho à noite",
  varLabelGust: "Rajadas de vento",
  varLabelTcdc: "Nebulosidade total",
  varLabelCape: "Energia potencial convectiva disponível",
  varLabelCin: "Inibição convectiva",
  varLabelVis: "Visibilidade",
  varLabelDpt2m: "Ponto de orvalho a 2 m",
  varLabelAptmp2m: "Sensação térmica a 2 m",
  varLabelLcdc: "Nebulosidade baixa",
  varLabelMcdc: "Nebulosidade média",
  varLabelHcdc: "Nebulosidade alta",
  varLabelPwat: "Água precipitável",
  varLabelHpbl: "Altura da camada limite planetária",
  varLabelPtype: "Tipo de precipitação",
  varLabelTmpsfc: "Temperatura da superfície do mar (temperatura da superfície em terra)",
  varLabelIcec: "Cobertura de gelo marinho",
  varLabelIcetk: "Espessura do gelo marinho",
  varLabelWave: "Ondas: altura significativa e direção",
  varLabelHtsgw: "Altura significativa das ondas",
  varLabelPerpw: "Período da onda primária",
  varLabelDirpw: "Direção da onda primária",
  varLabelWindwave: "Vaga: altura significativa e direção",
  varLabelSwell: "Ondulação: altura significativa e direção (primeira componente)",
  varLabelWvhgt: "Altura significativa da vaga",
  varLabelWvper: "Período médio da vaga",
  varLabelWvdir: "Direção da vaga",
  varLabelSwhgt: "Altura significativa da ondulação (primeira componente)",
  varLabelSwper: "Período médio da ondulação (primeira componente)",
  varLabelSwdir: "Direção da ondulação (primeira componente)",
  varLabelAod: "Espessura óptica de aerossóis a 550 nm",
  varLabelAoddust: "Espessura óptica de poeira",
  varLabelAodsalt: "Espessura óptica de sal marinho",
  varLabelAodsulf: "Espessura óptica de sulfato",
  varLabelAodorg: "Espessura óptica de carbono orgânico",
  varLabelAodbc: "Espessura óptica de carbono negro",
  varLabelPm25: "Concentração de PM2,5 à superfície",
  varLabelPm10: "Concentração de PM10 à superfície",
  varLabelPm10dust: "Concentração de PM10 de poeira à superfície",
  varLabelDustsfc: "Concentração de poeira à superfície",
  varLabelTsoil1: "Temperatura do solo, camada 1",
  varLabelTsoil2: "Temperatura do solo, camada 2",
  varLabelTsoil3: "Temperatura do solo, camada 3",
  varLabelTsoil4: "Temperatura do solo, camada 4",
  varLabelSoilw1: "Humidade volumétrica do solo, camada 1",
  varLabelSoilw2: "Humidade volumétrica do solo, camada 2",
  varLabelSoilw3: "Humidade volumétrica do solo, camada 3",
  varLabelSoilw4: "Humidade volumétrica do solo, camada 4",
  varLabelPrmsl: "Pressão ao nível médio do mar",
  varLabelHeightAtLevel: "Altura geopotencial de {level} hPa",
  varLabelTempAtLevel: "Temperatura de {level} hPa",
  varLabelRhAtLevel: "Humidade relativa de {level} hPa",
  varLabelSpfhAtLevel: "Humidade específica de {level} hPa",
  varLabelWindAtLevel: "Vento de {level} hPa",
  varLabelQfluxAtLevel: "Fluxo de vapor de água de {level} hPa",
  varLabelVvelAtLevel: "Velocidade vertical a {level} hPa",
  varLabelThetaeAtLevel: "Temperatura potencial equivalente a {level} hPa",
  varLabelCatAtLevel: "Turbulência de ar claro a {level} hPa (EDR)",
  legendSubtropicalHigh: "linha 588",
  webglUnavailable: "Este navegador não fornece um contexto WebGL2",
  pointerRequestFailed: "O pedido do ponteiro em direto devolveu HTTP {status}",
  manifestRequestFailed: "O pedido do manifesto devolveu HTTP {status}",
  bundleRequestFailed: "O pedido do pacote devolveu HTTP {status}",
  bundleTooLong: "O pacote excede o comprimento declarado pelo manifesto",
  bundleLengthMismatch: "O comprimento do pacote não corresponde ao manifesto",
  bundleChecksumMismatch: "A soma de verificação do pacote não corresponde",
  bundleRunMismatch: "O ciclo do pacote não corresponde ao manifesto",
  bundleMissingVariable: "Falta a variável {id} no pacote",
  manifestMissingBundle: "O manifesto não tem pacote para a variável {id}",
  mosaicNoMembers: "Nenhum conjunto de dados de satélite do mosaico está disponível",

  probeAria: "Série temporal do ponto",
  probeHint: "Reproduza ou arraste para completar a série",
  probeComplete: "Série completa",
  probeOutside: "Fora da grelha deste conjunto de dados",
  probeNoData: "Sem dados neste fotograma",
  probeAwaiting: "A aguardar este fotograma",
  probeModelElevationLabel: "Modelo",
  probeDemLabel: "DEM",
  probeCloseAria: "Fechar os dados do ponto",
  cardCloseAria: "Fechar o cartão",

  centerHigh: "A",
  centerLow: "B",

  showcaseLink: "Casos",
  showcaseBack: "← Todos os casos",
  showcaseHome: "Previsão ao vivo",
  showcaseTitle: "Casos de estudo",
  showcaseHeading: "Episódios meteorológicos, revistos",
  showcaseArchive: "arquivo",
  showcaseIntro:
    "Cada caso é uma fatia de um episódio meteorológico passado — um ciclo de previsão arquivado, ou observações — pelo mesmo codificador, recortado à região e às horas em que aconteceu.",
  showcaseMetaDescription:
    "Repetições de episódios meteorológicos passados: conjuntos de dados de previsão e de radar recortados para tufões, chuvadas, ondas de calor e mais",
  showcaseLoading: "A carregar o catálogo de casos",
  showcaseEmpty: "Ainda não há casos publicados",
  showcaseLoadFailed: "Falha ao carregar o catálogo de casos: {message}",
  showcaseCaseMissing: "Não há nenhum caso chamado {id}",
  showcaseEventLabel: "Episódio",
  showcaseRunLabel: "Ciclo",
  showcaseSeriesLabel: "Início",
  showcaseRangeLabel: "Alcance",
  showcaseSpanLabel: "Duração",
  showcaseRegionLabel: "Região",
  showcaseGridLabel: "Grelha",
  showcaseSizeLabel: "Tamanho",
  showcaseVariablesLabel: "Campos",
  showcaseHours: "{count} h",
  showcaseCaseAria: "Abrir o caso {title}",
  showcaseListAria: "Lista de casos de estudo",

  tcTileTip: "Ciclones tropicais",
  varTc: "TRAJETO",
  glyphTc: "C",
  tcSheetAria: "Ciclones tropicais",
  tcHeading: "Ciclones tropicais",
  tcAllSystems: "Todos os sistemas numerados",
  tcNone: "Sem sistemas ativos",
  tcUnnamed: "Sistema sem nome",
  tcDisturbances: "Perturbações e depressões",
  tcPotential: "Sistemas potenciais",
  tcPotentialShow: "Mostrar {count} sistemas só de modelos",
  tcModelOnly: "só modelo",
  tcAgencies: "Previsões oficiais",
  tcModels: "Trajetórias de modelos",
  tcMembers: "Membros do conjunto",
  tcBest: "Melhor trajetória",
  tcOptionsAria: "Opções de ciclones",
  tcHistoryHeading: "Ciclones tropicais passados",
  tcHistoryIntro: "Cada tempestade numerada do arquivo: as trajetórias finais dos centros, cada previsão feita para ela e quanto cada uma errou.",
  tcHistorySeasonsAria: "Temporada",
  tcHistoryBasinsAria: "Bacia",
  tcHistoryAll: "Todas",
  tcHistoryEmpty: "Nenhuma tempestade com previsões nesta temporada e bacia",
  tcHistoryStormAria: "Abrir {name}",
  tcHistorySouthernNote: "As temporadas do hemisfério sul vão de julho a junho e levam o ano em que terminam: a temporada {season} vai de {from} a {to}.",
  tcPageTitle: "Ciclone tropical passado",
  tcPageMetaDescription: "Um ciclone tropical passado: as trajetórias finais dos centros, cada previsão arquivada para ele e quanto cada uma errou.",
  tcPageLoading: "Carregando tempestade",
  tcPageMissing: "Nenhuma tempestade arquivada chamada {id}",
  tcPageFailed: "Falha ao carregar a tempestade: {message}",
  tcPageIssue: "Momento",
  tcPageNoForecast: "nenhuma previsão começa aqui",
  tcPagePrev: "Previsão anterior",
  tcPageNext: "Previsão seguinte",
  tcPageSources: "Trajetórias exibidas",
  tcPageErrorsHeading: "Erro de trajetória, km",
  tcPageTruth: "Em relação à trajetória final de",
  tcPageSource: "Fonte",
  tcPageErrorsMean: "Média da tempestade",
  tcPageErrorsThis: "A previsão no mapa",
  tcPageErrorsNone: "Nenhuma previsão desta tempestade foi verificada ainda contra esta trajetória final",
  tcPageNote: "Distância até a trajetória final nos horários sinóticos, contada só enquanto o sistema é um ciclone tropical ou subtropical; um conjunto é avaliado pela média. As previsões oficiais ficam ao lado de modelos iniciados no mesmo horário, que terminaram depois de a previsão oficial ser emitida.",
  tcPageId: "Código ATCF",
  tcPageLife: "Vida",
  tcPagePeak: "Vento máximo",
  tcPageForecasts: "Previsões",
  tcCardSeasons: "Temporadas",
  tcCardStorms: "Tempestades",
  tcPageDetails: "Página da tempestade",
  tcPageSeasonList: "Todas as tempestades da temporada",
  tcCardBrowse: "Por temporada",
  tcPageRadii: "Raios de vento",
  tcLegendIntensity: "Intensidade: trajetória final dos EUA, vento de 1 min",

  soundingTileTip: "Radiossondagens",
  varSounding: "ALTITUDE",
  glyphSounding: "S",
  airportTileTip: "Observações de aeroporto",
  varAirport: "METAR",
  glyphAirport: "A",
  synopTileTip: "Estações meteorológicas de superfície",
  varSynop: "SUPERFÍCIE",
  glyphSynop: "W",
  radarTileTip: "Radar de um local",
  varRadarSite: "LOCAL",
  glyphRadarSite: "D",
  radarProductAria: "Produto de radar",
  radarLatest: "mais recente",
  radarCloseAria: "Voltar ao mosaico",
  radarReflectivity: "Refletividade",
  radarVelocity: "Velocidade radial",
  stationSounding: "Radiossondagem",
  stationAirport: "Aeroporto",
  stationObserved: "Observado",
  stationFreezingLevel: "Isoterma de 0 °C",
  stationPw: "Água precipitável",
  stationCategory: "Categoria de voo",
  stationVisibility: "Visibilidade",
  stationQnh: "QNH",
  stationLevels: "Níveis",
  stationSynop: "Estação meteorológica",
  stationHumidity: "Umidade",
  stationPrecipitation: "Precipitação",
  stationPressure: "Pressão na estação",
  stationSeaLevelPressure: "Pressão ao nível do mar",
  stationSunshine: "Insolação",
  stationSnowDepth: "Altura da neve",
  stationElevation: "Altitude",
  stationOpenSounding: "Abrir a sondagem",
  stationPinHere: "Fixar aqui",
  fireTileTip: "Focos de incêndio (NASA FIRMS, últimas 24 h)",
  varFire: "FOCOS",
  glyphFire: "F",
  fireDetection: "Foco de incêndio",
  fireAcquired: "Adquirido",
  fireRadiativePower: "Potência radiativa",
  fireBrightness: "Temperatura de brilho",
  fireConfidence: "Confiança",
  fireConfidenceLow: "baixa",
  fireConfidenceNominal: "nominal",
  fireConfidenceHigh: "alta",
  fireOverpass: "Passagem",
  fireDay: "dia",
  fireNight: "noite",
  aqTileTip: "Estações de qualidade do ar (PM2.5)",
  varAq: "PM2.5",
  glyphAq: "Q",
  aqStation: "Qualidade do ar",
  aqAgency: "Órgão",
  aqNetwork: "Rede",
  aqPreliminary: "Dados preliminares: não validados, sujeitos a alteração",
  aqDayRange: "PM2.5, últimas 24 h",
  aqNearest: "Estação de qualidade do ar mais próxima, {km} km",
  alertsTileTip: "Alertas meteorológicos em vigor",
  varAlerts: "ALERTAS",
  glyphAlerts: "!",
  alertsCardTitle: "Alertas",
  alertsInForceNow: "Em vigor agora",
  alertsAsOf: "às {time}",
  alertsLevel: "Nível {level}",
  alertsUntilCancelled: "até ser cancelado",
  alertsIssued: "emitido {time}",
  alertCategoryRain: "Chuva forte",
  alertCategoryFlood: "Inundação",
  alertCategoryLandslide: "Deslizamento",
  alertCategoryWind: "Vento",
  alertCategoryThunderstorm: "Trovoada",
  alertCategorySnowIce: "Neve e gelo",
  alertCategoryHeat: "Calor",
  alertCategoryCold: "Frio",
  alertCategoryFog: "Nevoeiro",
  alertCategoryDust: "Poeira",
  alertCategoryFire: "Risco de incêndio",
  alertCategoryAir: "Qualidade do ar",
  alertCategoryCoastal: "Costeiro",
  alertCategoryMarine: "Marítimo",
  alertCategoryTsunami: "Tsunami",
  alertCategoryOther: "Outro",
  markerPlace: "Local",
  markerEvent: "Evento",
  markerSources: "Fontes",
  caseMarkersAria: "Locais e eventos deste caso",
  casePartsAria: "Partes deste evento",
  riverHeading: "Vazão dos rios",
  riverTracksAria: "Execução do modelo hidrológico",
  riverTrackAnalysis: "Análise",
  riverTrackForecast: "Previsão {cycle}",
  riverKeyAria: "Vazão em relação à habitual",
  riverRatio2: "< 2× a habitual",
  riverRatio10: "2–10×",
  riverRatio100: "10–100×",
  riverRatioMax: "≥ 100×",
  riverKeyField: "Colorido pela vazão, na escala do campo",
  riverExtents: "Áreas inundadas",
  riverGaugeHint: "Os círculos são estações fluviométricas: clique numa para ver o hidrograma.",
  riverObserved: "medido",
  riverModelled: "modelo",
  riverPeaks: "Picos reportados",
  riverGaugeLoading: "carregando…",
  riverGaugeUnavailable: "indisponível",

  soundingObserved: "OBS",
  soundingModel: "MODELO",
  soundingNoModel: "sem modelo em 12 h",
  soundingLoading: "A ler a sondagem…",
  soundingUnavailable: "Sondagem indisponível",
  soundingExpand: "Gráfico completo",
  soundingClose: "Fechar",
  soundingSheetHeading: "Sondagem",
  soundingSheetAria: "Gráfico da sondagem",

  // The comparison page (compare.html).
  compareLink: "Comparar",
  compareTitle: "Comparar previsões",
  compareHeading: "Comparação de modelos",
  compareEyebrow: "ponto",
  compareIntro:
    "Todos os modelos de previsão ao vivo num ponto, sobre um mesmo relógio: o que cada ciclo diz para as próximas horas, ao lado das observações do aeroporto mais próximo.",
  compareMetaDescription:
    "Compare as previsões do GFS, ECMWF, AIFS, IFS HRES e HRRR num ponto, hora a hora, com as observações METAR do aeroporto mais próximo.",
  compareLatitude: "Latitude",
  compareLongitude: "Longitude",
  compareLocate: "Usar a minha localização",
  compareLocateFailed: "Localização indisponível",
  compareOnMap: "No mapa",
  compareSpan5: "5 dias",
  compareSpan15: "15 dias",
  compareFieldsAria: "Campos a comparar",
  compareModelsAria: "Blocos de comparação de modelos",
  compareLoading: "A ler {model}…",
  compareModelFailed: "{model}: {message}",
  compareOffGrid: "fora da grelha deste modelo",
  compareNoModels: "Nenhum modelo cobre este ponto",
  compareHide: "Ocultar",
  compareShow: "Mostrar",
  comparePin: "Fixar no topo",
  compareHidden: "Modelos ocultos",
  compareRun: "Ciclo",
  compareObservationsFrom: "Observações de {icao}",
  compareNoAirport: "Nenhum aeroporto a menos de 40 km",
  compareHours: "Horas",
  compareNow: "agora",
  compareCells: "Cada valor é a célula da grelha do próprio modelo mais próxima do ponto, nunca uma interpolação; as horas são mostradas no seu fuso horário.",
  metricsMetaDescription: "Quando cada rodada de previsão do Xue entrou no ar, medido a partir dos workflows de publicação: latência após o horário do ciclo, ciclos ausentes e o que estava no ar no fechamento do mercado do dia seguinte da ERCOT.",
  metricsHeading: "Chegada das rodadas",
  metricsEyebrow: "medido",
  metricsIntro: "Quando cada rodada de previsão entrou no ar neste site, lido dos próprios registros dos workflows de publicação: o momento em que o ponteiro ao vivo foi gravado e quanto tempo depois do horário do ciclo do modelo isso ocorreu.",
  metricsNotSla: "São medições, não um nível de serviço: o Xue não assume compromisso de disponibilidade.",
  metricsGenerated: "Gerado em {time}, últimos {days} dias",
  metricsLoading: "Lendo métricas…",
  metricsEmpty: "Ainda não há métricas. Elas são geradas a cada seis horas a partir dos workflows de publicação; volte após a próxima geração.",
  metricsFailed: "Não foi possível ler as métricas: {message}",
  metricsSourcesHeading: "Por fonte",
  metricsLatencyNote: "A latência vai do horário do ciclo ao momento em que a rodada entrou no ar, então inclui o tempo de produção do próprio modelo. Todos os horários em UTC.",
  metricsTimelineNote: "Cada faixa é a janela: uma barra por ciclo que entrou no ar, no horário do ciclo, com a latência como altura em relação à maior da fonte; uma marca sob a linha é um ciclo que nunca chegou.",
  metricsTypicalNote: "* Típico na origem: um valor de experiência de quando os dados do próprio modelo costumam estar completos após o horário do ciclo, não uma medição. Em branco onde não há.",
  metricsTimelineAria: "Chegadas de {model} na janela",
  metricsCadence: "a cada {hours} h",
  metricsLatest: "Última rodada",
  metricsLanded: "No ar às",
  metricsLatency: "Latência",
  metricsMedian: "Mediana",
  metricsMax: "Máx.",
  metricsTypical: "Típico na origem",
  metricsCycles: "Ciclos chegados",
  metricsMissing: "Ausentes",
  metricsMissingList: "Ciclos ausentes",
  metricsRuns: "Execuções do workflow",
  metricsOutcomeLanded: "no ar",
  metricsOutcomeSkipped: "pulada",
  metricsOutcomeDryRun: "simulação",
  metricsOutcomeFailed: "falhou",
  metricsBacklog: "{count} execuções do workflow ainda não lidas; a próxima geração as lê.",
  metricsDeadlinesHeading: "No fechamento",
  metricsDeadlineIntro: "Para cada dia local, a rodada mais recente já no ar no horário limite e a idade do seu ciclo naquele momento.",
  metricsSource: "Fonte",
  metricsCommonest: "Usual",
  metricsNoneLive: "nenhuma",
  glyphAurora: "A",
  varAurora: "PROB",
  varDis06: "6H",
  varDisrp: "RP",
  varUpstream: "ÁREA",
  fieldGroupSpace: "Clima espacial",
  fieldGroupFire: "Fogo",
  modelGroupForecast: "Modelos de previsão",
  modelGroupRadar: "Radar",
  varLabelAurora: "Probabilidade de auroras visíveis",
  varLabelDis06: "Caudal fluvial (média de 6 h)",
  varLabelDisrp: "Classe de período de retorno",
  varLabelUpstream: "Área drenada a montante",
  creditsAurora: "Clima espacial: probabilidade de auroras, modelo OVATION da NOAA SWPC",
  creditsEfas: "Caudal fluvial: Copernicus EMS EFAS v5, Europa 1′; só casos",
  creditsEra5: "Reanálise: Copernicus C3S ERA5 (ECMWF), global 0,25°, horário, CC-BY-4.0; só casos",
  creditsCams: "Análise de aerossóis: Copernicus CAMS (ECMWF), global 0,4°, a cada 3 horas, CC-BY-4.0; só casos",
};
